import Page, { Section, ExternalLink } from './Page';

export default Page;
export { Section, ExternalLink };
